module.exports = __webpack_public_path__ + "img/slide2.b190ce5f.webp";